module.exports = __webpack_public_path__ + "static/media/20170806_32day_1631AT.6cbebd06.jpg";